module.exports = __webpack_public_path__ + "img/accessory_shoe_05.98aca0fc.svg";